<template>
  <v-container id="validation-forms" fluid tag="section">
    <loading :active.sync="loading"></loading>

    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card light color="success" icon="mdi-mail" class="py-3 px-5">
          <v-card-title class="justify-center">
            <h1>Reiniciar contraseña</h1>
          </v-card-title>
          <v-form>
            <v-text-field
              v-model="password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="password"
              @input="$v.password.$touch()"
              :error-messages="passwordErrors"
              @blur="$v.password.$touch()"
              color="blue darken-3"
              label="Ingrese la nueva Contraseña"
              hint="Al menos son 8 caracteres"
              prepend-icon="mdi-lock"
              @click:append="show = !show"
            ></v-text-field>

            <v-text-field
              v-model="password_2"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show2 ? 'text' : 'password'"
              color="blue darken-3"
              :error-messages="passwordErrors_2"
              label="Repita la constraseña"
              hint="La contraseña debe ser igual a la de arriba"
              prepend-icon="mdi-lock"
              requiered
              @input="$v.password_2.$touch()"
              @blur="$v.password_2.$touch()"
              @click:append="show2 = !show2"
            ></v-text-field>

            <v-card-actions class="pa-0">
              <v-spacer />

              <v-btn color="success" @click="ResetPass_">Cambiar contraseña</v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  email,
  sameAs,
  minLength,
  alphaNum
} from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["userEmail"],
  mixins: [validationMixin],
  validations: {
    password: {
      required,
      goodPassword: password => {
        return (
          password.length >= 8 &&
          /[a-z]/.test(password) &&
          /[A-Z]/.test(password) &&
          /[0-9]/.test(password) &&
          /[!#$%&'()*+,-./:;<=>?@[\]^_{|}~]/.test(password)
        );
      }
    },
    password_2: {
      required,
      sameAsPassword: sameAs("password")
    }
  },

  name: "",

  $_veeValidate: {
    validator: "new"
  },
  created() {},
  data: () => ({
    show: false,
    show2: false,
    password: "",
    password_2: "",
    loading: false
  }),
  components: {
    Loading
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.goodPassword &&
        errors.push(
          "La contraseña debe tener minimo <br> 1. Una letra minuscula <br> 2. Una letra mayuscula <br> 3. Un signo !#$%&()*+,-./:;<=>?@[]^{|}~ "
        );
      !this.$v.password.required && errors.push("La contraseña es requerida");

      return errors;
    },
    passwordErrors_2() {
      const errors = [];
      if (!this.$v.password_2.$dirty) return errors;
      !this.$v.password_2.required && errors.push("Este campo es reuerido");
      !this.$v.password_2.sameAsPassword &&
        errors.push("La constraseña no coincide");
      return errors;
    }
  },

  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          alert("Form Submitted!");
        }
      });
    },
    ResetPass_() {
      this.$v.$touch();
      if (this.$v.password.required) {
        let userEmail = this.$route.query.userEmail,
          userId = this.$route.query.userId,
          _token = this.$route.query.token;
        this.loading = true;

        axios
          .post("/api/User/resetPassword", {
            userId: userId,
            password: this.password,
            confirmedPassword: this.password_2,
            token: _token.replace(/ /g, "+")
          })
          .then(result => {
            return result.data;
          })
          .then(data => {
            this.loading = false;
            if (data.error) {
              Swal.fire({
                title: "Error",
                text:
                  "Ocurrio un error al actualizar la contraseña, esta liga ya no es valida",
                type: "error",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK"
              }).then(result => {
                if (result.value) {
                  this.$router.push({ name: "Login" });
                }
              });
            } else {
              Swal.fire({
                title: "Exito",
                text: "La contraseña se reestablecio correctamente",
                type: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK"
              }).then(result => {
                if (result.value) {
                  this.$router.push({ name: "Login" });
                }
              });
            }
          })
          .catch(err => {
            this.loading = false;
            Swal.fire({
              title: "Error",
              text:
                "Ocurrio un error al actualizar la contraseña, vuelva a intentarlo",
              type: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK"
            }).then(result => {
              if (result.value) {
                /*  this.$router.push({name:'Login'})     */
              }
            });
          });
      }
    }
  }
};
</script>
